import React, { Component } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { Container } from 'reactstrap';

import {
  AppAside,
  AppBreadcrumb,
  AppFooter,
  AppHeader,
  AppSidebar,
  AppSidebarFooter,
  AppSidebarForm,
  AppSidebarHeader,
  AppSidebarMinimizer,
  AppSidebarNav,
} from '@coreui/react';
// sidebar nav config
import navigation from '../../_nav';
// routes config
import routes from '../../routes';

import DefaultAside from './DefaultAside';
import DefaultFooter from './DefaultFooter';
import DefaultHeader from './DefaultHeader';
import Loader from '../../views/Loader'
import { fetchAboutMe } from '../../views/services/'
import { UserContext } from '../../contexts'


class DefaultLayout extends Component {

  state = {
    loading: true,
    redirect: false,
    avatar: null,
    lifeStage: null
  }

  changeAvatar = (avatar) => {
    console.log(avatar)
    this.setState(prevState => ({
      avatar
    }));
  }

  changeLifeStage = (lifeStage) => {
    console.log(lifeStage);
    this.setState(prevState => ({
      lifeStage
    }))
  }

  async componentDidMount() {
    try {

      const response = await fetchAboutMe();
      
      this.setState(prevState => ({
        avatar: response.data.about.image,
        lifeStage: response.data.about.lifeStage,
        loading: false
      }))

    } catch(err) {
      if(err.response.status === 401) {
        this.setState(prevState => ({
          loading: false,
          redirect: true
        }))
      }
    }

  }

  render() {

    console.log(navigation);

    if(this.state.loading === true) {
      return <Loader />
    }

    if(this.state.redirect  === true) {
      return <Redirect to="/login" />
    }

    let navigationList = [...navigation.items];
    if(this.state.lifeStage === undefined || this.state.lifeStage < 4) {
      navigationList.splice(3, 1);
      console.log(navigationList);
    }


    return (
      <div className="app">
        {/* <Loader isActive={this.state.loading}/> */}
        <AppHeader fixed>
          <UserContext.Provider value={this.state.avatar}>
            <DefaultHeader />
          </UserContext.Provider>
        </AppHeader>
        <div className="app-body">
          <AppSidebar fixed display="lg">
            <AppSidebarHeader />
            <AppSidebarForm />
            <AppSidebarNav navConfig={{ items: navigationList}} {...this.props} />
            <AppSidebarFooter />
            <AppSidebarMinimizer />
          </AppSidebar>
          <UserContext.Provider value={{changeAvatar: this.changeAvatar, changeLifeStage: this.changeLifeStage }}>
            <main className="main">
              {/* <AppBreadcrumb appRoutes={routes}/> */}
              <Container fluid>
                <Switch>
                  {routes.map((route, idx) => {
                      if(route.path == "/dashboard") {
                        return route.component ? (<Route key={idx} path={route.path} name={route.name} render={props => (
                          <route.component {...props} lifeStage={this.state.lifeStage} />
                        )}/>)
                        : (null)
                      }

                      if(route.path == "/accountsetting") {
                        return route.component ? (<Route key={idx} path={route.path} name={route.name} render={props => (
                          <route.component {...props} changeLifeStage={this.changeLifeStage} />
                        )}/>)
                        : (null)
                      }

                      return route.component ? (<Route key={idx} path={route.path} exact={route.exact} name={route.name} render={props => (
                          <route.component {...props} />
                        )} />)
                        : (null);
                    },
                  )}
                  <Redirect from="/" to="/dashboard" />
                </Switch>
              </Container>
            </main>
          </UserContext.Provider>
          <AppAside fixed hidden>
            <DefaultAside />
          </AppAside>
        </div>
        <AppFooter>
          <DefaultFooter />
        </AppFooter>     
      </div>
    );
  }
}

export default DefaultLayout;



// WEBPACK FOOTER //
// ./src/containers/DefaultLayout/DefaultLayout.js